import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { logout } from "@/lib/http/auth"
import { ROUTES } from "@/routes/path"

export default function SelectOrganization() {
  const navigate = useNavigate()

  return (
    <div className="flex h-screen flex-col bg-gray-50 dark:bg-zinc-900 lg:flex-row">
      {/* Left column: features */}
      <div className="z-0 hidden w-1/2 flex-col bg-gradient-to-tr from-amber-300 via-lime-200 to-green-300 px-16 lg:flex">
        <div className="mt-10">
          <img src="/logo.svg" alt="Ledgerbeam" width={220} height={50} />
        </div>
        <ul className="mt-24 space-y-8 text-black">
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Get started quickly</h5>
            <p className="mt-1 pl-4">Create or join an organization to start collaborating.</p>
          </li>
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Support any business model</h5>
            <p className="mt-1 pl-4">
              Ecommerce, fintech, SaaS platforms, marketplaces, and more—all within a unified platform.
            </p>
          </li>
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Join millions of businesses</h5>
            <p className="mt-1 pl-4">Ledgerbeam is trusted by ambitious startups and enterprises of every size.</p>
          </li>
        </ul>
      </div>

      <div className="mt-6 flex justify-center lg:hidden">
        <img src="/logo.svg" alt="Ledgerbeam" width={220} height={50} />
      </div>

      {/* Right column: selection card */}
      <div className="relative flex flex-1 justify-center p-4 md:items-center lg:py-10">
        <div className="relative z-10 w-full max-w-lg">
          <div className="rounded-xl bg-white p-8 shadow-xl dark:bg-zinc-800">
            <h1 className="mb-2 text-2xl font-semibold dark:text-zinc-100">Let&apos;s get you started!</h1>
            <p className="mb-6 text-zinc-600 dark:text-zinc-400">
              To get started, you have to be part of an organization.
            </p>
            <div className="flex flex-col space-y-3">
              <Button
                variant="secondary"
                className="h-12 bg-black text-white hover:bg-black/80"
                onClick={() => navigate(ROUTES.DASHBOARD.ORGANIZATION.CREATE)}
              >
                Create new organization
              </Button>
              <Button
                variant="secondary"
                className="h-12 border border-zinc-200 bg-white text-black hover:bg-zinc-100 dark:border-zinc-700 dark:bg-zinc-800 dark:text-white dark:hover:bg-zinc-700"
                onClick={() => navigate(ROUTES.DASHBOARD.ORGANIZATION.JOIN)}
              >
                Join existing organization
              </Button>
            </div>
          </div>
          <div className="-mt-4 w-full max-w-lg rounded-b-xl border-t bg-gray-50 px-8 py-5 text-center text-sm text-muted-foreground shadow-md shadow-gray-200 dark:border-zinc-700 dark:bg-zinc-800 dark:shadow-zinc-700">
            Want to use a different account?{" "}
            <span
              onClick={() => logout()}
              className="cursor-pointer font-medium text-primary hover:underline dark:text-primary"
            >
              Log out
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
